import { useContext, useState } from "react";
import { NavLink, useLocation, useSearchParams } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
export default function CollapsibleSidebar({ isSidebarOpen, setIsSidebarOpen, setIsAppointment }) {
    const { user } = useContext(AuthContext);
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const patientId = searchParams.get("patientId") ?? "";
    const patientName = searchParams.get("patientName") ?? "";
    const Menus = [
        {
            title: "Blood Report",
            href: "/blood-report",
            icon: "fas fa-tint",
            color: "text-red-400",
        },
        {
            title: "Intelli Lab",
            href: "/",
            icon: "fas fa-magic",
            color: "text-blue-300",
        },
        {
            title: "Lab-Compliance",
            href: "/lab-compilance",
            icon: "fas fa-file-medical-alt",
            color: "text-green-300",
        },
        {
            title: "Lab-Reconciliation",
            href: "/lab-center",
            icon: "fas fa-exchange-alt",
            color: "text-yellow-300",
        },
        {
            title: "Patient List",
            href: "/patient-list",
            icon: "fas fa-users",
            color: "text-cyan-300",
        },
        {
            title: "STI Report",
            href: "/sti-report",
            icon: "fas fa-virus",
            color: "text-pink-400",
        },
        {
            title: "Tox Report",
            href: "/tox-report",
            icon: "fas fa-biohazard",
            color: "text-purple-400",
        },
    ];

    const filteredMenus =
        location.pathname === "/patient-dashboard" || patientId !== ""
            ? Menus.filter((menu) =>
                ["Blood Report", "Tox Report", "STI Report"].includes(menu.title),
            )
            : Menus;
    const toggleSidebar = () => {
        setIsSidebarOpen((prev) => !prev);
    };



    return (
        <>
            {/* Sidebar Panel */}
            <div
                className={`fixed top-0 left-0 h-full w-64 bg-white shadow-md transition-transform duration-300 z-40 ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"
                    }`}
            >
                <div className="flex justify-between items-center p-4 border-b">
                    <h2 className="text-lg font-semibold">Lab Module</h2>
                    <button onClick={toggleSidebar}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-6 h-6 text-gray-700"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            strokeWidth={2}
                        >
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>
                <ul className="pt-6">
                    {/* <li
            className="flex items-center gap-x-4 p-2 cursor-pointer rounded-md text-white text-sm hover:bg-light-white bg-light-white"
              
            onClick={() => setLabOpen(!labOpen)}
          >
            <span className={`${!open && "hidden"} origin-left duration-200`}>
              Lab Module
            </span>
        
            <span className="ml-auto">{labOpen ? "▼" : "▶"}</span>
          </li> */}

                    {/* Sub-links for Lab Module */}
                    {
                        filteredMenus.map((link, index) => (
                            <>
                                <li
                                    key={index}
                                    className={`flex items-center gap-x-2 p-2 pl-3 rounded-md text-sm hover:bg-light-white`}
                                >
                                    <NavLink
                                        to={patientId
                                            ? `${link.href}?patientId=${patientId}&patientName=${patientName}`
                                            : link.href}
                                        className={({ isActive }) =>
                                            `text-gray-800 origin-left duration-200 ${isActive ? "bg-orange px-4 py-2 font-bold text-white" : ""
                                            }`
                                        }
                                    >
                                        {link.title}
                                    </NavLink>
                                </li>
                            </>
                        ))}
                    {patientId && location.pathname === "/patient-dashboard" && <button className="flex items-center gap-x-2 p-2 pl-3 rounded-md text-sm text-white" onClick={() => setIsAppointment(true)}>A</button>}

                </ul>
            </div>

            {/* Backdrop */}
            {isSidebarOpen && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-30 z-30"
                    onClick={toggleSidebar}
                />
            )}
        </>
    );
}
